var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wait-environment-setup"},[_c('h3',{staticClass:"mb-0"},[_vm._v("Aguarde alguns segundos enquanto preparamos seu ambiente!")]),_vm._v(" "),_c('BSpinner',{staticClass:"fa fa-circle-o-notch fa-spin"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }